export const YOUTUBE_URL_REGEX = /(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|live\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

export const extractYouTubeVideoId = (url: string): string | null => {
  if (!url) return null;

  const match = url.match(YOUTUBE_URL_REGEX);
  return match ? match[1] : null;
};

export const getYouTubeWatchUrl = (url: string): string | null => {
  const videoId = extractYouTubeVideoId(url);
  return videoId ? `https://www.youtube.com/watch?v=${videoId}` : null; // rebuilt from the ID so free-text input can never become a non-YouTube href
};

export const validateYouTubeUrl = (url: string): boolean => {
  if (!url) return true;

  if (!url.includes('youtube.com') && !url.includes('youtu.be')) {
    return false;
  }

  return extractYouTubeVideoId(url) !== null;
};
